import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import WorkspaceGateway from '../WorkspaceGateway';
var InvitationRSVP = observer(_class = /*#__PURE__*/function (_React$Component2) {
  function InvitationRSVP() {
    _classCallCheck(this, InvitationRSVP);
    return _callSuper(this, InvitationRSVP, arguments);
  }
  _inherits(InvitationRSVP, _React$Component2);
  return _createClass(InvitationRSVP, [{
    key: "render",
    value: function render() {
      var _this = this;
      var token = this.props.params.token;
      return /*#__PURE__*/React.createElement(WorkspaceGateway, {
        rootStore: this.props.rootStore,
        invitationToken: token
      }, function () {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: _this.props.rootStore.workspaceSelectorStore.inviteToPath
        });
      });
    }
  }]);
}(React.Component)) || _class;
export { InvitationRSVP as default };
var Redirect = /*#__PURE__*/function (_React$Component) {
  function Redirect() {
    _classCallCheck(this, Redirect);
    return _callSuper(this, Redirect, arguments);
  }
  _inherits(Redirect, _React$Component);
  return _createClass(Redirect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.context.router.replace(this.props.to);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, "plz wait");
    }
  }]);
}(React.Component);
Redirect.contextTypes = {
  router: PropTypes.any
};
//# sourceMappingURL=index.js.map
